import React from 'react';
import { getProduct } from '../../product-catalog/productPresentation';
import { assetUrl } from '../shared/assetUrl';

export default function LessonCard({ lesson, selected, onSelect, t }) {
  return (
    <button
      type="button"
      className={`learning-card${selected ? ' learning-card-selected' : ''}`}
      aria-expanded={selected}
      aria-controls="learning-player"
      onClick={event => onSelect(lesson.id, event.currentTarget)}
    >
      <span className="learning-card-preview">
        <img src={assetUrl(lesson.poster)} alt="" width="1920" height="1080" />
        <span className="learning-play" aria-hidden="true">▶</span>
        <span className="learning-duration">{lesson.duration}</span>
      </span>
      <span className="learning-card-content">
        <span className="learning-card-title">{lesson.titleKey ? t(lesson.titleKey) : getProduct(lesson.productId).name}</span>
        <span className="learning-card-description">{t(lesson.descriptionKey)}</span>
        <span className="learning-card-action">
          {t(selected ? 'learning.selected' : 'learning.openVideo')}
          <span aria-hidden="true">{selected ? '✓' : '→'}</span>
        </span>
      </span>
    </button>
  );
}

